import { RegisterOnboardingErrorDetail } from '../types/auth/register';

interface ErrorResponse {
  data?: {
    detail?: RegisterOnboardingErrorDetail | string | Record<string, unknown>;
    message?: string;
  };
  message?: string;
}

export function parseRegisterOnboardingError(
  err: unknown
): RegisterOnboardingErrorDetail | null {
  const detail = (err as ErrorResponse)?.data?.detail;
  if (
    detail &&
    typeof detail === 'object' &&
    'onboarding_error' in detail &&
    detail.onboarding_error === true
  ) {
    return detail as RegisterOnboardingErrorDetail;
  }
  return null;
}

export function parseRegisterError(err: unknown): string {
  const onboarding = parseRegisterOnboardingError(err);
  if (onboarding) return onboarding.message;

  const detail = (err as ErrorResponse)?.data?.detail;
  if (typeof detail === 'string') return detail;

  const response = err as ErrorResponse;
  return (
    response?.data?.message ||
    response?.message ||
    'Registration failed. Please try again.'
  );
}

export function buildOnboardingMailtoLink(
  contactEmail: string,
  teamName: string
): string {
  const subject = encodeURIComponent('Team onboarding help');
  const body = encodeURIComponent(`Team: ${teamName}`);
  return `mailto:${contactEmail}?subject=${subject}&body=${body}`;
}
